import { ErknmAnalyticsColumnTypesEnum } from 'APIPackage/ErknmAnalyticsModule/enums/ErknmAnalyticsColumnTypesEnum';
import { IErknmAnalyticsColumnIndex } from 'APIPackage/ErknmAnalyticsModule/interfaces/IErknmAnalyticsColumnIndex';

import { IErknmAnalyticsTableColumn } from '../interfaces/IErknmAnalyticsTableColumn';

export const convertColumnsDataToTableColumns = (
  columns?: IErknmAnalyticsColumnIndex[],
): IErknmAnalyticsTableColumn[] | undefined => {
  return columns?.map<IErknmAnalyticsTableColumn>((item, index) => ({
    id: item.c,
    name: item.n,
    isActive:
      item.s === ErknmAnalyticsColumnTypesEnum.PRIMARY ||
      item.s === ErknmAnalyticsColumnTypesEnum.SECONDARY ||
      item.s === ErknmAnalyticsColumnTypesEnum.WARNING,
    isMain: item.s === ErknmAnalyticsColumnTypesEnum.PRIMARY,
    isWarning: item.s === ErknmAnalyticsColumnTypesEnum.WARNING,
    mainId: item.s === ErknmAnalyticsColumnTypesEnum.DEFAULT ? index.toString() : undefined,
    cs: item.cs,
    valueType: item.t,
  }));
};
